const DEFAULT_API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://thrivenig-backend.vercel.app/api";

const addProtocol = (value) => {
  const url = String(value || "").trim();
  if (!url || /^(?:https?:)?\/\//i.test(url) || url.startsWith("/")) return url;
  return `https://${url}`;
};

export const API_BASE_URL = addProtocol(
  process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL
).replace(/\/+$/, "");

export const apiUrl = (path = "") =>
  `${API_BASE_URL}/${String(path).replace(/^\/+/, "")}`;
